import { useAppSelector } from "../../../../../stateManagement/hooks/redux"

// RoadWorkSegmentsPODD
export default function RWSPODDContent() {
    const data = useAppSelector(state => state.mapTooltip.data)
    const { LengthAlongRoad, ExecutorOrgName } = data ?? {}
    const formattedLength = typeof LengthAlongRoad === 'number'
        ? LengthAlongRoad.toFixed(2).replace('.', ',')
        : (LengthAlongRoad ?? null)

    return (
        <>
            <div className="tooltip-info-row">Протяжённость: {formattedLength} км</div>
            <div className="tooltip-info-row">Исполнитель: {ExecutorOrgName ?? 'Не известен'}</div>
        </>
    )
}
